import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";

export const summaryNoteRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.list.route,
      lazy: () => import("@pages/panelPages/summaryNotes/summaryNoteListPage"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.past-visit-summary-notes",
            [],
            "index",
            "main",
          );
        return {};
      },
    },
    permissions: ["doctor", "super-admin", "patient", "staff"],
  },
  {
    route: {
      path: path.management.route,
      lazy: () =>
        import(
          "@pages/panelPages/summaryNoteManagement/summaryNoteManagementListPage"
        ),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(
            request,
            "pageTitle.summary-note-management",
            [],
            "index",
            "main",
          );
        return {};
      },
    },
    permissions: ["doctor", "staff"],
  },
  {
    route: {
      path: path.writeSummary.route,
      lazy: () =>
        import("@pages/panelPages/writeSummaryNote/writeSummaryNotePage"),
      loader: ({ request }) => {
        useUIStore.getState().setPage(
          request,
          "pageTitle.writeSummaryNote",
          [
            {
              title: "pageTitle.summary-note-management",
              url: path.management.link(),
            },
          ],
          "edit",
        );
        return {};
      },
    },
    permissions: ["doctor", "staff"],
  },
  {
    route: {
      path: path.viewSummary.route,
      lazy: () =>
        import("@pages/panelPages/viewSummaryNote/viewSummaryNotePage"),
      loader: ({ request }) => {
        useUIStore.getState().setPage(
          request,
          "pageTitle.viewSummaryNote",
          [
            {
              title: "pageTitle.summary-note-management",
              url: path.management.link(),
            },
          ],
          "index",
        );
        return {};
      },
    },
    permissions: [
      "doctor",
      "patient",
      "admin",
      "staff",
      "local-admin",
      "super-admin",
    ],
  },
  {
    route: {
      path: path.writeAddendum.route,
      lazy: () => import("@pages/panelPages/writeAddendum/writeAddendumPage"),
      loader: ({ request }) => {
        useUIStore.getState().setPage(
          request,
          "pageTitle.writeAddendum",
          [
            {
              title: "pageTitle.summary-note-management",
              url: path.management.link(),
            },
          ],
          "edit",
        );
        return {};
      },
    },
    permissions: ["doctor", "staff"],
  },
  {
    route: {
      path: path.patientSummaryList.route,
      lazy: () => import("@pages/panelPages/summaryNotes/summaryNoteListPage"),
      loader: ({ request }) => {
        useUIStore.getState().setPage(
          request,
          "pageTitle.patient-past-visit-summary-notes",
          [
            {
              title: "pageTitle.past-visit-summary-notes",
              url: path.list.link(),
            },
          ],
          "index",
        );
        return {};
      },
    },
    permissions: ["doctor", "super-admin", "patient"],
  },
];
